import { render, staticRenderFns } from "./TableValoresRemocaoLocalidade.vue?vue&type=template&id=612ed45c&scoped=true&"
import script from "./TableValoresRemocaoLocalidade.vue?vue&type=script&lang=js&"
export * from "./TableValoresRemocaoLocalidade.vue?vue&type=script&lang=js&"
import style0 from "./TableValoresRemocaoLocalidade.vue?vue&type=style&index=0&id=612ed45c&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612ed45c",
  null
  
)

export default component.exports